import { hostnames } from 'features/common/config/envConfig';
import { AuditLogsSupportedSystemName } from '../constants';

export const baseAuditLogsApiUrl = {
  [hostnames.internal]:
    'https://edge-platform-staging.sitecore-staging.cloud/v1/audit',
    // 'https://audit-api-staging.sitecore-staging.cloud/api/v2',
  [hostnames.localhost]:
    'https://edge-platform-staging.sitecore-staging.cloud/v1/audit',
    // 'https://audit-api-staging.sitecore-staging.cloud/api/v2',
  [hostnames.dev]:
    'https://edge-platform-dev.sitecore-staging.cloud/v1/audit',
    // 'https://audit-api-dev.sitecore-staging.cloud/api/v2',
  [hostnames.qa]:
    'https://edge-platform-qa.sitecore-staging.cloud/v1/audit',
    // 'https://audit-api-qa.sitecore-staging.cloud/api/v2',
  [hostnames.staging]:
    'https://edge-platform-staging.sitecore-staging.cloud/v1/audit',
    // 'https://audit-api-staging.sitecore-staging.cloud/api/v2',
  [hostnames.beta]: 'https://edge-platform-preprod.sitecorecloud.io/v1/audit',
  [hostnames['pre-production']]:
    'https://edge-platform-preprod.sitecorecloud.io/v1/audit',
  [hostnames.production]: 'https://edge-platform.sitecorecloud.io/v1/audit',
};

export const auditLogsApi = {
  get_logs: {
    /**
     * Build URL for fetching audit logs, including optional search query and tenantId.
     */
    url: ({
      system,
      continuationToken,
      tenantId,
    }: {
      system: AuditLogsSupportedSystemName;
      continuationToken: string;
      tenantId?: string;
    }) => {
      let url = `${
        baseAuditLogsApiUrl[window.location.hostname]
      }/logs?system=${system}&continuationToken=${continuationToken}`;

      if (tenantId) {
        url += `&tenantId=${encodeURIComponent(tenantId)}`;
      }

      return url;
    },
    scope: 'audit.logs:r',
  },
  get_systems: {
    /**
     * Build URL for fetching all related systems and tenants that have logs in the CAL under the caller’s organization.
     */
    url: () => {
      const url = `${
        baseAuditLogsApiUrl[window.location.hostname]
      }/systems`;
      
      return url;
    },
    scope: 'audit.logs:r platform.tenants:listall',
  },
};
